/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:1900px){.Company-totalsControls{display:flex;flex-wrap:nowrap}}.Company-totalsControls .FormElement-control{flex-wrap:wrap}.company-total{margin-left:.5rem;margin-right:.5rem}.Company-salaryTotalsGrid .k-grid-content{overflow:auto;height:60vh;min-height:465px}@media only screen and (max-width:1279px){.Company-salaryTotalsGrid .k-grid-content{height:480px}}@media only screen and (max-width:900px){.Card-total--right{margin-bottom:1rem}}"];
export { styles as styles };
